import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import { ListingSectionObservable } from './ListingSection';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import './ListingSurroundings.scss';

const ListingSurroundings = ({ transportationDescription = '' }) => (
  <ListingSectionObservable section="surroundings">
    <ListingTitle role="secondary">
      {trans('listing.surroundings.title')}
    </ListingTitle>
    {transportationDescription ? (
      <div className="listing-transportation">
        <ListingTitle role="tertiary">
          {trans('property_show.title.transportation')}
        </ListingTitle>
        <ListingContent content={transportationDescription} />
      </div>
    ) : null}
  </ListingSectionObservable>
);
ListingSurroundings.propTypes = {
  transportationDescription: PropTypes.string
};

export default ListingSurroundings;
